/**
 * mixins to Wechat Class
 */
// 缓存处理
import rest from '../rest'
import cache, { EXTERNAL_USERID_KEY } from '../common/cache'

export default {
  jsApiList: [
    'chooseWXPay',
    'openLocation',
    'scanQRCode',
    'chooseImage',
    'hideOptionMenu',
    'hideMenuItems',
    'onMenuShareWechat',
    'onMenuShareAppMessage',
    'onMenuShareTimeline',
    'uploadImage',
    'startRecord',
    'onVoiceRecordEnd',
    'stopRecord',
    'closeWindow',
    'previewImage',
    'getContext',
    'getCurExternalContact',
    'launchMiniprogram',
    'openDefaultBrowser',
    'sendChatMessage',
    'getCurExternalChat',
    'openEnterpriseChat'
  ],
  // 获取微信签名信息
  async getWechatConfigResource() {
    const res = await rest.wx.getWeChatConfigResource({
      from_url: window.encodeURIComponent(window.location.href.split('#')[0]),
      _from_agent: cache.getSessionData('DOS-FROM-AGENT') // url.getSearch()._from_agent
    })
    return res
  },
  payByWx(appId, timeStamp, nonceStr, packageStr, signType, paySign, success, cancel, fail) {
    let config = {
      appId: appId, // 公众号名称，由商户传入
      timeStamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
      package: packageStr, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
      signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: paySign // 支付签名
    }
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', config, res => {
      if (res.err_msg === 'get_brand_wxpay_request:ok' && success) {
        success(res)
      } else if (res.err_msg === 'get_brand_wxpay_request:cancel' && cancel) {
        cancel(res)
      } else if (res.err_msg === 'get_brand_wxpay_request:fail' && fail) {
        fail(res)
      }
    })
  },
  /**
   * 扫一扫
   */
  scanQRCode(callback) {
    this.wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: callback
    })
  },
  // 位置相关的微信接口
  openLocationByWx(latitude, longitude, name, address, scale, infoUrl) {
    this.wx.openLocation({
      latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
      longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
      name: name, // 位置名
      address: address, // 地址详情说明
      scale: scale, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: infoUrl // 在查看位置界面底部显示的超链接,可点击跳转
    })
  },
  getLocationByWx(type) {
    type = type || 'gcj02'
    let promise = new Promise((resolve, reject) => {
      // 获取地址
      this.wx.getLocation({
        type: type, // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res) => {
          // res.latitude // 纬度，浮点数，范围为90 ~ -90
          // res.longitude // 纬度，浮点数，范围为90 ~ -90
          resolve(res)
        },
        cancel: (res) => {
          reject(res)
        }
      })
    })
    return promise
  },
  // 分享到朋友圈
  shareTimeline(data) {
    this.wx.onMenuShareTimeline(data)
  },
  // 分享给朋友
  shareAppMessage(data) {
    this.wx.onMenuShareAppMessage(data)
  },
  hideOptionMenu() {
    this.wx.hideOptionMenu()
  },
  // 分享给微信
  // shareWechat () {
  //   this.wx.onMenuShareWechat()
  // },
  hideMenuItems(options) {
    let menuItems = (options && options.menuItems) || [
      'menuItem:share:appMessage',
      'menuItem:share:timeline',
      'menuItem:share:qq',
      'menuItem:share:weiboApp',
      'menuItem:share:favorite'
    ]
    this.wx.hideMenuItems({
      menuList: menuItems,
      success: res => {
        options && options.success && options.success()
      },
      fail: res => {
        options && options.fail && options.fail()
      }
    })
  },
  batchUploadImage(num, success) {
    let self = this.wx
    let images = { localIds: [], serverId: [] }
    if (num >= 9) num = 9
    this.wx.chooseImage({
      count: num,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: function(res) {
        images.localIds = res.localIds
        let i = 0
        let length = images.localIds.length
        let timer = null
        let upload = function() {
          self.uploadImage({
            localId: images.localIds[i],
            success: function(res) {
              images.serverId.push(res.serverId)
              // 如果还有照片，继续上传
              i++
              if (i < length) {
                clearTimeout(timer)
                timer = setTimeout(() => {
                  upload()
                }, 50)
              } else {
                timer = null
                success(images.serverId)
              }
            },
            fail: () => {
              throw new Error(`批量上传图片失败:${JSON.stringify(res)}`)
            }
          })
        }
        upload()
      }
    })
  },
  uploadImage(success) {
    let self = this.wx
    this.wx.chooseImage({
      count: 1,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: function(res) {
        let localId = res.localIds[0]
        if (localId === undefined) {
          return false
        }
        self.uploadImage({
          localId: localId,
          isShowProgressTips: 1,
          success: success,
          fail: (res) => {
            throw new Error(`上传图片失败:${JSON.stringify(res)}`)
          }
        })
      }
    })
  },
  startRecord(success, fail, complete) {
    this.wx.startRecord({
      success,
      fail,
      complete
    })
  },
  onVoiceRecordEnd(complete) {
    this.wx.onVoiceRecordEnd({
      complete
    })
  },
  stopRecord(success, fail, complete) {
    this.wx.stopRecord({
      success,
      fail,
      complete
    })
  },
  /**
   * 关闭窗口
   */
  closeWindow() {
    this.wx.closeWindow()
  },
  // 以下方法用于puloadPic相关的图片上传 begin

  /**
   *单个图片上传
  *
  * @param {*} i 当前上传的图片序号
  * @param {*} images 当前展示的图片数组
  * @param {string} [url=''] 上传图片请求的url地址
  * @param {number} [initLen=0] 图片数组的初始化长度
  * @param {string} [key='src'] 图片地址属性
  */
  imgUpLoad(_this, i, images, url = '', initLen = 0, key = 'src') {
    _this.$wechat.promise.then(wechat => {
      // 上传图片
      wechat.uploadImage((res) => {
        let mediaId = res.serverId
        // 通知后台同步刚上传的图片id
        _this.$rest.wx[url](null, mediaId).then((res) => {
          if (res.code === 0) {
            let url = res.data.url
            if (i === void 0) {
              // autoIncreateKey 为超过前面9张后的选填图片序号。后端需要 other_1  、other_2 这样作为参数名
              // let autoIncreateKey = images.length - initLen
              let newImg = {
                // code: `other_${autoIncreateKey}`,
                code: `other`,
                name: `其他`,
                name2: `（选填）` // 第二行名称
              }
              newImg[key] = url
              images.push(newImg)
            } else {
              images[i][key] = url
            }
          } else {
            _this.showToast(res.message)
          }
        })
      })
    }, wechat => {
      console.error('微信JSSDK校验错误:', wechat.res)
    })
  },
  /**
   *批量图片上传
  *
  * @param {*} i 当前上传的图片序号
  * @param {*} images 当前展示的图片数组
  * @param {string} [url=''] 上传图片请求的url地址
  * @param {string} [key='src'] 图片地址属性
  * @returns
  */
  batchImgUpload(_this, i, images, url = '', count, key = 'src') {
    if (count < images.length) return false
    let len = 0
    let num = 0
    images.forEach(v => {
      if (v[key] !== '') num++
    })
    len = count - num
    _this.$wechat.promise.then(wechat => {
      wechat.batchUploadImage(len, (serverIds) => {
        let ids = serverIds
        _this.$wechat.getImages(_this, ids, i, images, url, key)
      })
    }, wechat => {
      console.error('微信JSSDK校验错误:', wechat.res)
    })
  },
  /**
   *获取批量上传的图片
  *
  * @param {*} list
  * @param {*} i
  * @param {*} images
  * @param {*} url
  * @param {*} key
  */
  getImages(_this, list, i, images, url, key) {
    if (list && list.length) {
      let params = { media_ids: list }
      _this.switchLoading({ status: true, text: '加载中...' })
      _this.$rest.wx[url](params, 'multiple').then(res => {
        if (res.code === 0) {
          let urls = res.data.urls
          if (i !== void 0) {
            if (urls.length === 1) {
              images[i][key] = urls.shift()
            } else {
              images = images.map(item => {
                if (!item[key] && urls.length) {
                  item[key] = urls.shift()
                }
              })
            }
          }
          // 如果此时还有多余的图片，则添加到图片队列末尾
          if (urls.length > 0) {
            urls.forEach((o, i) => {
              let newImg = {
                code: `other_${i}`,
                name: `其他`,
                name2: `（选填）` // 第二行名称
              }
              newImg[key] = o
              images.push(newImg)
            })
          }
        } else {
          _this.showToast(res.message)
        }
        _this.switchLoading({ status: false })
      })
    }
  },
  /**
   *删除上传的图片
  *
  * @param {*} i 当前上传的图片序号
  * @param {*} images 当前展示的图片数组
  * @param {*} count 要求的图片张数
  * @param {*} key 图片地址属性
  */
  imgDelete(i, images, initLen = -1, key = 'src') {
    if (images.length > 0 && initLen < i) {
      images.splice(i, 1)
    } else {
      images[i][key] = ''
    }
  },
  // 以上方法用于puloadPic相关的图片上传 end

  // 新分享接口
  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
  updateAppMessageShareData(opt) {
    this.wx.updateAppMessageShareData(opt)
  },
  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
  updateTimelineShareData(opt) {
    this.wx.updateTimelineShareData(opt)
  },

  // 获取H5页面的入口环境
  getEntranceEnv() {
    return new Promise(resolve => {
      this.wx.invoke('getContext', {}, function (res) {
        resolve(res.entry)
      })
    })
  },
  // 获取当前外部联系人ID
  async getCurExternalUserId() {
    const entry = await this.getEntranceEnv()
    // 从群聊进入时，读缓存
    if (entry === 'group_chat_tools') {
      const value = cache.getSessionData(EXTERNAL_USERID_KEY)
      if (value) return value
    }
    if (!['single_chat_tools', 'contact_profile'].includes(entry)) return
    return new Promise(resolve => {
      // 缓存外部联系人id， 解决在页面中刷新会导致获取不到外部id
      const value = cache.getSessionData(EXTERNAL_USERID_KEY)
      if (value) {
        resolve(value)
        return
      }
      this.wx.invoke('getCurExternalContact', {}, function (res) {
        cache.setSessionData(EXTERNAL_USERID_KEY, res.userId)
        resolve(res.userId)
      })
    })
  },
  // 获取当前客户群的群ID
  async getCurExternalChat() {
    const entry = await this.getEntranceEnv()
    if (!['group_chat_tools'].includes(entry)) return
    return new Promise(resolve => {
      const CHATID_KEY = 'CHATID_KEY'
      const value = cache.getSessionData(CHATID_KEY)
      if (value) {
        resolve(value)
        return
      }
      this.wx.invoke('getCurExternalChat', {}, function (res) {
        cache.setSessionData(CHATID_KEY, res.chatId)
        resolve(res.chatId)
      })
    })
  }
}
